<template>
  <v-container class="white-wrapper pa-4" fluid>
    <div class="font-weight-bold">
      {{ $t('welcome') }}, {{ user.email || user.phone }}{{ $t('welcome_sir') }}
    </div>
    <template v-if="news.length > 0">
      <div class="notice-home">
        <router-link
          class="notice-link1"
          v-for="item in news"
          :key="item.cid"
          :to="`/config/news/${item.cid}`"
        >
          [<span>{{ $t('Notice.tiker') }}</span
          >] {{ item.title }}
        </router-link>
        <!--
          <a href="" class="notice-link">[<span>공지</span>] 내용...</a>
          <a href="" class="notice-link">[<span>공지</span>] 내용...</a>
          <a href="" class="">[<span>서비스런칭</span>] 내용...</a>
        -->
      </div>
    </template>
    <v-card color="primary" dark min-height="130" class="my-2">
      <v-card-title
        style="
          font-size: 1rem;
          display: flex;
          justify-content: space-between;
          align-items: center;
        "
      >
        <span>{{ $t('totalAssetValue') }}</span>
        <v-btn icon small style="margin-right: -5px" @click="refresh">
          <v-icon small>mdi-refresh</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="text-h4 font-weight-bold white--text text-end">
        $ {{ comma(fixedNum(totalAssets, 2)) }}
      </v-card-text>
    </v-card>
    <div class="d-flex flex-column">
      <template v-if="wallet.length > 0">
        <v-card
          outlined
          class="wallet-item px-2 my-1"
          v-for="(item, index) in wallet"
          :key="index"
        >
          <div class="d-flex">
            <div class="d-flex align-center justify-center mr-2">
              <v-img style="width: 2rem" :src="imgSrc(item.name)" />
            </div>
            <div class="d-flex align-start justify-center flex-column">
              <div class="text-subtitle-1 font-weight-bold">
                {{ item.name }}
              </div>
              <!-- 
              <div class="text-caption">
                {{ item.name }}: ￦ {{ comma(item.price) }}                 
              </div>
              -->

              <div v-if="item.address != false" class="text-caption">
                {{ item.address.substr(0, 23) }}

                <v-btn
                  icon
                  small
                  style="margin-right: -5px"
                  @click="copy_address(item.address)"
                >
                  <v-icon small>mdi-content-copy</v-icon>
                </v-btn>
              </div>
            </div>
          </div>
          <div class="d-flex align-end justify-center flex-column">
            <div
              class="text-subtitle-1 font-weight-bold"
              style="font-size: 1.3rem !important"
            >
              {{ comma(fixedNum(item.balance, 6)) }}
            </div>
            <div class="text-caption text-gray60">
              ≒ 
              ${{ comma(fixedNum( parseFloat(item.price) , 4)) }}
              <!-- {{ comma(fixedNum(item.balance * parseFloat(item.price), 2)) }} -->
            </div>
          </div>
        </v-card>
      </template>
      <template v-else>
        <div class="text-center">
          <v-progress-circular
            style="margin: 3rem auto"
            :size="50"
            :width="7"
            indeterminate
            color="primary"
          ></v-progress-circular>
        </div>
      </template>
    </div>

    <div v-show="true">
      <input type="text" id="wallet_copy" v-model="wallet_copy" />
    </div>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    wallet_copy: null,
    show: false,
    dialog: false,
    newsList: [],
    eventDialog: false,
    popupToday: false,
    bridgeTest: '',
    menuOn: false,
    popupTitle: null,
    popupLink: null,
    newsLength: 3,
    more: true,
    newsLoading: false,
  }),
  computed: {
    user() {
      return this.$store.getters.user
    },
    popup() {
      return {
        src: `https://bucket2paycam.s3-ap-southeast-1.amazonaws.com/image/${this.popupTitle}lotto_popup(${this.$i18n.locale}).png`,
        to: this.popupLink,
        num: this.popupTitle,
      }
    },
    myWalletAdress() {
      return this.$store.getters.user.wallet_address
    },
    wallet() {
      // console.log( this.$store.getters.wallet )
      // return this.$store.getters.wallet

      let _temp = this.$store.getters.wallet.filter(
        (i) =>
          i.name !== 'USDT-z' &&
          i.name !== 'DISE' &&
          i.name !== 'PCC' &&
          i.name !== 'PGP' //&& i.name !== 'ETH'
      )
      let _tempAry = []
      let _sort = [
        
        'UMUC',
        'UMMC',
        'UMCP','UMSC',
        'BNB',
        // 'ETH',
        // 'USDT',
        'TRX',
        'USDT-TRC',
        // 'EUR',
        // 'TRX',
        // 'HLM',
        // 'SOLANA',
        // 'STAIKA',
        // 'MATIC',
        // 'W3P',
        // 'W3C',
        // 'CCC',
        // 'LSS',
        // 'PCC',
        // 'PGP',
      ]
      //,"PRTG"

      _temp.map((item, i) => {
        _tempAry[_sort.indexOf(item.name)] = item
      })
      return _tempAry //Ary
    },
    currentLocale() {
      return this.$i18n.locales.find((i) => i.code === this.$i18n.locale)
    },
    availableLocales() {
      return this.$i18n.locales
    },
    news() {
      return this.newsList.slice(0, this.newsLength)
    },
    totalAssets() { 

      return this.wallet.length > 0
        ? this.wallet.reduce((acc, cur) => {            
            return acc + (  parseFloat(cur.balance , 2) * parseFloat(cur.price,2) )

          }, 0)
        : 0
    },
  },
  methods: {
    async copy_address(addr) {
      // alert(addr)
      this.wallet_copy = addr

      let codeToCopy1 = await document.querySelector('#wallet_copy')
      codeToCopy1.setAttribute('type', 'text')
      codeToCopy1.select()

      try {
        var successful = await document.execCommand('copy')

        if (successful) {
          await this.$store.dispatch('toast', {
            toast: true,
            toast_msg: 'Address has been copied.',
            timeout: 2000,
          })
        } else throw new Error('fail')
      } catch (err) {
        await this.$store.dispatch('toast', {
          toast: true,
          toast_msg: 'Copying Address failed.',
          timeout: 2000,
        })
      }

      codeToCopy1.setAttribute('type', 'hidden')
      window.getSelection().removeAllRanges()
    },
    imgSrc(item) {
      // console.log( item )
      let src
      try {
        src = require(`@/assets/svg/${item + '-logo.svg'}`)
      } catch (e) {
        try {
          src = require(`@/assets/svg/${item + '-logo.png'}`)
        } catch (e) {
          src = require(`@/assets/svg/ETH-logo.svg`)
        }
      }
      return src
    },
    moreNewsList() {
      this.newsLoading = true

      const fnc = () => {
        this.newsLength = this.newsLength + 3
        this.newsLoading = false
      }
      if (this.newsLength < this.newsList.length) setTimeout(fnc, 1000)

      if (this.newsLength >= this.newsList.length) this.more = false
    },
    onClickPopupToday() {
      this.eventDialog = false
      let expiredays = 7
      // console.log(document.cookie)
      let today = new Date()
      today = new Date(
        parseInt(today.getTime() / 86400000) * 86400000 + 54000000
      )
      if (today > new Date()) {
        expiredays = expiredays - 1
      }
      today.setDate(today.getDate() + expiredays)
      this.$cookies.set('p' + this.popup.num, escape(true), today.toGMTString())
    },
    refresh() {
      if (this.myWalletAdress) {
        this.$store.dispatch('FETCH_WALLET')
      }
    },
    onMessageHandler(e) {
      try {
        const event = JSON.parse(e.data)
        const token = event.token
        const os = event.os

        // register_push
        const params = { os: os, token: token }
        this.$store
          .dispatch('register_push', params)
          .then((res) => {})
          .catch((err) => {})
        // register_push
      } catch (error) {
        console.error('error')
        return
      }
    },
    sendMessage(str) {
      window.ReactNativeWebView.postMessage(str)
    },
    receiveMessage(event) {
      // alert("받은 데이터(Web) : "+event.data);
      this.postMessage = event.data
    },
  },
  created() {
    this.$store.dispatch('FETCH_USERINFO').then(() => {
      this.$store.dispatch('FETCH_WALLET')
    })
    // console.log()
    this.$store.commit('activeMenu', 'home')
    // if (this.myWalletAdress) {
    //   this.$store.dispatch('FETCH_WALLET')
    // }
    this.$store.dispatch('w_l_contents').then((res) => (this.newsList = res))

    if (window.ReactNativeWebView) {
      // 푸시토큰 수집
      window.ReactNativeWebView.postMessage(JSON.stringify({ key: 'token' }))
    }

    // this.$store.dispatch('w_l_popup').then((res) => {
    //   // console.log(res)
    //   if (res.data) {
    //     this.popupTitle = res.data.pop_title
    //     this.popupLink = res.data.pop_link
    //     const popup = this.$cookies.get('p' + res.data.pop_title)

    //     if (popup !== 'true') this.eventDialog = true
    //   } else {
    //     this.eventDialog = false
    //   }
    // })
  },
  mounted() {
    const isUIWebView = () => {
      return navigator.userAgent
        .toLowerCase()
        .match(/\(ip.*applewebkit(?!.*(version|crios))/)
    }
    const receiver = isUIWebView() ? window : document
    receiver.addEventListener('message', this.onMessageHandler)
  },
}
</script>

<style scoped>
.notice-home {
  background-color: #efefef;
  border-radius: 7px;
  height: 105px;
  padding: 14px;
  font-size: 0.9rem;
  margin-bottom: 10px;
}
/* .notice-home > a {
  display: block;
  position: relative;
  width: 100%;
  color: #9A9A9A;
  margin-bottom: 7px;
} */
.notice-home > a {
  display: block;
  position: relative;
  width: 100%;
  color: #9a9a9a;
  margin-bottom: 7px;
  padding-right: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-break: break-all;
}

.notice-home > a:last-child {
  margin-bottom: 0;
}
.notice-home > a.notice-link::before {
  display: inline;
  content: 'NEW';
  font-weight: bold;
  margin-right: 7px;
}
.notice-home > a.notice-link {
  margin-left: 0;
}
.notice-home > a::after {
  display: inline-block;
  content: '';
  width: 12px;
  height: 12px;
  background: url(../../src/assets/icon/home_notice_arrow.svg);
  position: absolute;
  top: 3px;
  right: 0;
}

.wallet-item {
  min-height: 4.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.wallet-item .col {
  padding: 0.2rem;
}
.logo-container {
  text-align: center;
}
.news-card {
  width: 12rem;
  max-width: 12rem;
  height: 15rem;
  margin-right: 0.8rem;
  box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%),
    0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}
.news-title {
  width: 100%;
  height: 10rem;
  color: #fff;
  padding: 1rem;
  font-size: 1.3rem;
  font-weight: bold;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  white-space: normal;
  line-height: 1.3;
  height: 6rem;
  text-align: left;
  word-wrap: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
.view-btn {
  position: relative;
  bottom: 0;
  width: 8rem;
  margin: 1rem 2rem;
}
.news-container {
  width: inherit;
  display: flex;
  overflow-x: auto;
  padding: 1rem 0;
  align-items: center;
}
.news-overlay {
  width: inherit;
  height: inherit;
  border-radius: inherit;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.news-content p img {
  width: 100%;
}
.news-content p {
  margin: 0 !important;
}
.close-button {
  display: fixed;
}
.popup-title {
  font-size: 1.1rem;
  font-weight: 600;
  padding-bottom: 0.3rem;
}
</style>
